
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: {
    img: String,
    text: String,
    funcao: Function,
    chave: String,
    nome: String,
    valExt: String,
    idExt: Number,
    valPhoto: String,
    checked: Boolean,
  },
})
export default class CleanListTwoParams extends Vue {}
